import { useFetch } from '@/hooks/useFetch';
import { env } from '@/utils/constants/env';
import createRulesObject from '@/utils/functions/tasklist/createRulesObject';
import { Select } from 'alurkerja-ui';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';

export const InputSelectUrl = ({ fieldSpec, setValue, control }: any) => {
  const rulesObject = createRulesObject(fieldSpec);

  const fetchUrlOptions = fieldSpec.properties.URL.includes('https://')
    ? fieldSpec.properties.URL
    : env.apiTasklistBaseUrl + fieldSpec.properties.URL;

  const { data, isFetching } = useFetch({
    path: fetchUrlOptions,
  });

  let selectOptions: { label: string; value: string }[] = [];

  if (data != undefined) {
    const options = (data as any[]).map((option: any) => {
      return {
        label: option[fieldSpec.properties.OPTION_LABEL],
        value: option[fieldSpec.properties.OPTION_KEY],
      };
    });
    selectOptions = options;
  }

  return (
    <div>
      <label
        className={classNames('font-medium', {
          'after:content-["*"] after:text-red-400 after:text-sm': fieldSpec.constraints?.required,
        })}
        htmlFor={fieldSpec.name}
      >
        {fieldSpec.label}
      </label>
      <Controller
        name={fieldSpec.name}
        control={control}
        rules={rulesObject}
        render={({ fieldState }) => {
          return (
            <>
              <Select
                onChange={(e: any) => {
                  setValue(fieldSpec.name, e.value);
                }}
                options={selectOptions}
                isLoading={isFetching}
                id='select-id'
              ></Select>
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
            </>
          );
        }}
      ></Controller>
    </div>
  );
};
